export default (theme) => ({
    container: {
        margin: '8px 0',
        padding: '12px 8px',
        backgroundColor: theme.colors.grey[800],
        borderRadius: 8,
        transition: 'padding .4s cubic-bezier(0, 0, 0.3, 1)',
        willChange: 'padding',
        minWidth: 56,
        '& > span': {
            display: 'inherit',
        },
    },
    environmentSelector: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 42,
        marginBottom: 8,
        padding: '4px',
        border: `1px solid transparent`,
        borderRadius: 8,
        boxSizing: 'border-box',
        cursor: 'pointer',
        transition: 'padding .4s cubic-bezier(0, 0, 0.3, 1)',
        '&:hover': {
            backgroundColor: theme.colors.grey[700],
        },
    },
    environmentSelectorActive: {
        backgroundColor: theme.colors.grey[600],
        border: `1px solid ${theme.colors.grey[400]}`,
        '&:hover': {
            backgroundColor: theme.colors.grey[600],
        },
    },
    environmentSelectorContainer: {
        flex: 1,
        overflow: 'hidden',
    },
    environmentSelectorText: {
        marginTop: -4,
    },
    environmentCount: {
        textAlign: 'center',
    },
    isExpanded: {
        padding: '12px 8px',
        '& $environmentSelector': {
            padding: '4px 16px',
        },
    },
    itemsList: {},
    menuItem: {
        margin: '0',
    },
    popoverContainer: {
        width: 352,
        backgroundColor: theme.colors.grey[900],
        borderTopRightRadius: 8,
        borderBottomRightRadius: 8,
        '& .hoi-poi-popover-inner': {
            padding: 16,
            backgroundColor: theme.colors.grey[900],
        },
    },
    popoverContentWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        maxHeight: 338,
        overflow: 'hidden',
    },
    searchInput: {
        flexShrink: 0,
        '& [class*="HoiPoi__InputWrapper__inputWrapper"]': {
            padding: 0,
        },
    },
    environmentsList: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        ...theme.utils.scrollbar,
    },
    environmentItem: {
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
        gap: 8,
        height: 36,
        padding: '0px 12px',
        backgroundColor: 'transparent',
        borderRadius: 4,
        boxSizing: 'border-box',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
        '&:hover': {
            backgroundColor: theme.colors.grey[900],
        },
    },
    selectAllItem: {},
    environmentItemIndented: {
        paddingLeft: 24,
    },
    environmentItemDisabled: {
        cursor: 'not-allowed',
        '& [class*="HoiPoi__Checkbox__root"]': {
            cursor: 'not-allowed',
        },
        '&:hover': {
            backgroundColor: 'transparent !important',
        },
    },
    environmentLabel: {
        flex: 1,
        color: theme.colors.primary.white,
    },
    noResultsText: {
        width: '100%',
        textAlign: 'center',
        padding: '4px',
        boxSizing: 'border-box',
    },
    adviceContainer: {
        position: 'relative',
        marginTop: 4,
        flexShrink: 0,
    },
    advice: {
        backgroundColor: theme.colors.grey[50],
        border: 'none',
        paddingRight: 32,
        '& path': {
            fill: theme.colors.textLight.secondary,
        },
        '& span': {
            color: `${theme.colors.textLight.secondary} !important`,
        },
    },
    adviceCloseIcon: {
        position: 'absolute',
        top: 8,
        right: 8,
        cursor: 'pointer',
    },
});
